import { CKButton } from '@clearkit/react';
import { Link } from 'react-router-dom';

import FacebookIcon from '~/images/services/Facebook.svg';
import GoogleIcon from '~/images/services/Google.svg';
import {
  audienceSubtypes,
  audienceSubtypeServices,
  readableAudienceSubtype,
} from '~/lib/audiences';
import {
  destinationNameForType,
  destinationSubtitleForType,
  destinationTypes,
} from '~/lib/destinations';
import paths from '~/lib/paths';
import Logo from '~/pages/destinations/components/Logo';

import styles from './styles';

const AddDestinationOrAudience = ({
  destinationType,
  classes,
  segment,
  audienceSubtype,
  name,
  subtitle,
  footer,
  className,
  services,
}) => {
  let url;
  let rel;
  if (audienceSubtype) {
    rel = `add-${audienceSubtype}-audience`;
    if (audienceSubtype === audienceSubtypes.companySegmentProspects) {
      url = paths.audienceNew(audienceSubtype, {
        segmentId: segment.id,
        segmentType: segment.type,
      });
    } else {
      url = paths.audienceNewSyncStep(audienceSubtype, {
        segmentId: segment.id,
        segmentType: segment.type,
      });
    }
  } else {
    rel = `add-${destinationType}-destination`;
    url = paths.segmentDestinationNew(segment.type, segment.id, {
      type: destinationType,
    });
  }

  return (
    <div className={classnames(classes.destinationColumn, className)} rel={rel}>
      <div className={classes.destinationDetailsWrapper}>
        <Logo
          className={classes.destinationLogo}
          audienceSubtype={audienceSubtype}
          destinationType={destinationType}
        />
        <div className={classes.destinationNameWrapper}>
          <span className={classes.destinationName}>{name}</span>
          <span className={classes.destinationDescription}>{subtitle}</span>
        </div>
        <CKButton
          className={classes.destinationButton}
          as={Link}
          disabled={!segment}
          to={url}>
          Create...
        </CKButton>
      </div>

      {services && (
        <>
          <hr className={classes.separator} />
          <div className={classes.footer}>
            {services.includes('facebook') && (
              <FacebookIcon style={{ width: 16, height: 16 }} />
            )}
            {services.includes('google') && (
              <GoogleIcon style={{ width: 16, height: 16, marginLeft: 8 }} />
            )}
            <span className={classes.footerText}>
              Supports sync to{' '}
              {services.length === 2 ? (
                <>Facebook Retargeting & Google Remarketing</>
              ) : (
                <>Facebook Custom Audiences</>
              )}
            </span>
          </div>
        </>
      )}
      {footer && <div className={classes.destinationSection}>{footer}</div>}
    </div>
  );
};

AddDestinationOrAudience.propTypes = {
  classes: PropTypes.object,
  destinationType: PropTypes.oneOf(destinationTypes),
  index: PropTypes.number,
  segment: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    __typename: PropTypes.string,
  }),
  audienceSubtype: PropTypes.string,
  name: PropTypes.string,
  subtitle: PropTypes.node,
  footer: PropTypes.string,
  className: PropTypes.string,
  services: PropTypes.array,
};

export const StyledAddDestinationOrAudience = withStyles(styles)(
  AddDestinationOrAudience,
);

const audienceSubtitles = {
  [audienceSubtypes.contacts]:
    'Sync all segment matches to a contacts audience',
  [audienceSubtypes.visitors]:
    'Retarget website visitors when they match this segment',
  [audienceSubtypes.companySegmentProspects]:
    'Find and advertise to people who work at companies within this segment.',
};

export const AddAudience = (props) => {
  const subtitle = audienceSubtitles[props.subtype];

  return (
    <StyledAddDestinationOrAudience
      name={`${readableAudienceSubtype(props.subtype)} Audience`}
      subtitle={subtitle}
      services={audienceSubtypeServices(props.subtype)}
      audienceSubtype={props.subtype}
      {...props}
    />
  );
};

export const AddDestination = (props) => {
  return (
    <StyledAddDestinationOrAudience
      name={destinationNameForType(props.type)}
      subtitle={destinationSubtitleForType(props.type, props.segment.type)}
      destinationType={props.type}
      {...props}
    />
  );
};

AddAudience.propTypes = AddDestination.propTypes = {
  type: PropTypes.string,
  segment: PropTypes.shape({
    type: PropTypes.string,
  }),
};
